import Vue from 'vue'
import VueAxios from 'vue-axios'
import axios from 'axios';

Vue.config.productionTip = false
Vue.use(VueAxios, axios);

import App from './App.vue'
import VueGtag from "vue-gtag";

import router from './router'

import Vuelidate from 'vuelidate'
import store from './store'
import vuetify from './plugins/vuetify';
import filters from './filters';


import '@mdi/font/css/materialdesignicons.css'


Vue.use(Vuelidate);
Vue.use(filters);
Vue.use(VueGtag, {
  config: { id: "GT-PBSRP54" }
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
